export default __webpack_public_path__ + "static/media/Luxuary.3b05f978.svg";